// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2F_mD","inner":"Footer_inner__2eEag"};